// extracted by mini-css-extract-plugin
module.exports = {"userFormattedText":"Truncate_userFormattedText_mxbQ7"};